/*
* @Des 组件 项目管理
* @Description
* @Author
* @Date 2025/11/3
*/
<template>
	<div class="view-tree-table sub-router-view">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;项目管理</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<OrgModule ref="OrgModule" />
    </div>
</template>

<script>
	// 组件 项目管理
	import OrgModule from '@/components_outdoor/Organization/OrgModule'

	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2025/11/3
		 */
		name: 'Organization',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2025/11/3
		 */
		components: {
			// 组件 项目管理
			OrgModule,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2025/11/3
		 */
		props: {

		},

		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2025/11/3
		 */
		created() {
			
		},// created
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2025/11/3
		 */
		mounted() {

		},// mounted
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2025/11/3
		 */
		beforeDestroy() {
			
		},// beforeDestroy

		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2025/11/3
		 */
		data() {
			return {
				// 当前选中 标签
				activeName: 'first',
				/**
				 * @Des 轨迹数据
				 * @Auth
				 * @Date 2025/11/3
				 */
				trackInfo: {},
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2025/11/3
		 */
		methods: {
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
              // 路由 子模块 name
              this.routerSubName = '';
              // 跳转到 首页
              this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter

            /**
             * @Des 点击tab标签(之前)
             * @Auth
             * @Date 2025/11/3
             */
            beforeHandle(tab, event){
            	
            },// beforeHandle
            
		},// methods

	}// export default
</script>

/* CSS */
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/views/system-outdoor/organization/Organization.vue